module.exports = "/fonts/vendor/dropify/dist/dropify.ttf?86cb1ab018f1680d8e0fa0ca6a53d64c";